import { render, staticRenderFns } from "./ElipseIcon.vue?vue&type=template&id=24be3798&scoped=true&"
import script from "./ElipseIcon.vue?vue&type=script&lang=ts&"
export * from "./ElipseIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be3798",
  null
  
)

export default component.exports